import React, { type FC } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss, Text } from '@atlaskit/primitives';
import { IconButton } from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';
import type { NewCoreIconProps } from '@atlaskit/icon';
import Tooltip from '@atlaskit/tooltip/Tooltip';

export type InfoBoxProps = {
	text: string;
	beforeLabel?: string;
	afterLabel?: string;
	BeforeIcon?: React.ComponentType<NewCoreIconProps>;
	AfterIcon?: React.ComponentType<NewCoreIconProps>;
	/**
	 * Tooltip wraps the AfterIcon if provided. No tooltip with be shown if AfterIcon
	 * is not provided.
	 */
	tooltipMessage?: string;
};

const backgroundStyle = xcss({
	borderRadius: 'radius.medium',
	padding: 'space.100',
	background: token('color.background.accent.gray.subtlest'),
});

export const InfoBox: FC<InfoBoxProps> = ({
	text,
	beforeLabel = '',
	afterLabel = '',
	BeforeIcon,
	AfterIcon,
	tooltipMessage,
}: InfoBoxProps) => {
	return (
		<Box as="section" xcss={backgroundStyle}>
			<Inline space="space.100" alignBlock="center">
				{BeforeIcon && <BeforeIcon label={beforeLabel} size="medium" />}
				<Inline alignBlock="center">
					<Text>{text}</Text>
					{AfterIcon && (
						<>
							{tooltipMessage ? (
								<Tooltip content={tooltipMessage} position="bottom">
									{(tooltipProps) => (
										<IconButton
											{...tooltipProps}
											icon={AfterIcon}
											label={afterLabel}
											appearance="subtle"
											spacing="compact"
										/>
									)}
								</Tooltip>
							) : (
								<AfterIcon label={afterLabel} size="medium" />
							)}
						</>
					)}
				</Inline>
			</Inline>
		</Box>
	);
};
